import axios from "axios";
import { apiVariable } from "./apiVariable";
import { TrailerComplianceMatrixDto } from "../interfaces/Fleet/TrailerComplianceMatrixDto";

export const getTrailerComplianceMatrix = async (token?: string) => {
  const { data } = await axios.get<TrailerComplianceMatrixDto[]>(
    `${apiVariable}/getTrailerComplianceMatrix`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return data;
};

export const getTrailerComplianceMatrixByTrailerId = async (
  trailerId: string,
  token?: string,
) => {
  const { data } = await axios.get<TrailerComplianceMatrixDto>(
    `${apiVariable}/getTrailerComplianceMatrix/${trailerId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return data;
};
